import * as React from 'react';
import * as ReactDom from 'react-dom';
import ModalContent from './ModalContent';

export default (props) => {
  if (!props.open) return null;

  return ReactDom.createPortal(
    <div className='calendly-overlay'>
      <div
        onClick={props.onModalClose}
        className='calendly-close-overlay'
      ></div>
      <div className='calendly-popup'>
        <div className='calendly-popup-content'>
          <ModalContent {...props} />
        </div>
      </div>
      <button
        className='calendly-popup-close'
        onClick={props.onModalClose}
        aria-label='Close modal'
        style={{
          display: 'block',
          border: 'none',
          padding: 0,
        }}
      ></button>
    </div>,
    props.rootElement
  );
};



// WEBPACK FOOTER //
// ./src/components/Calendly/Modal/index.js